import React from "react";
import { useTranslation } from "react-i18next";

import { LocationData } from "../../../models/LocationData";
import "./styles.scss";

export interface IModalLinkLocationsConfirmProps {
  orgName: string;
  addedLocations: LocationData[];
  removedLocations: LocationData[];
  onClose: () => void;
  onConfirm: () => void;
}

export const ModalLinkLocationsConfirm: React.FunctionComponent<
  IModalLinkLocationsConfirmProps
> = (props) => {
  const { orgName, addedLocations, removedLocations, onClose, onConfirm } =
    props;
  const { t: _t } = useTranslation();

  const t = (key: string, params?: any) =>
    _t(`organizationManagementPage.modalLinkLocationsConfirm.${key}`, params);

  return (
    <div className="modal modal-default modal-link-locations-confirm">
      <div className="modal-mains">
        <button
          className="btn-close"
          aria-label="Close"
          onClick={onClose}
        ></button>
        <div className="top-title">{t("title")}</div>

        <div className="confirm-content-scrollable">
          {/* Added facilities (Upper Section) */}
          <div className="confirm-section added-section">
            {addedLocations.length !== 0 && (
              <>
                {" "}
                <div className="section-title">
                  {t("added_title", { orgName })}
                </div>
                <ul className="facilities-list">
                  {addedLocations.map((loc) => (
                    <li key={loc.id} className="facility-item">
                      {`• ${loc.name}`}
                    </li>
                  ))}
                </ul>
              </>
            )}
          </div>

          {/* Removed facilities (Lower Section, Red text) */}
          <div className="confirm-section removed-section">
            {removedLocations.length !== 0 && (
              <>
                <div className="section-title red-text">
                  {t("removed_title", { orgName })}
                </div>
                <ul className="facilities-list">
                  {removedLocations.map((loc) => (
                    <li key={loc.id} className="facility-item red-text">
                      {`• ${loc.name}`}
                    </li>
                  ))}
                </ul>
              </>
            )}
          </div>
        </div>

        {/* Bottom actions */}
        <div className="bottom-btns">
          <button className="btn btn-border rounded-btn" onClick={onClose}>
            {t("cancel")}
          </button>
          <button className="btn btn-blue rounded-btn" onClick={onConfirm}>
            {t("confirm")}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ModalLinkLocationsConfirm;
